import request from "@/router/axios";

export const getList = (current, size, params) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/submit",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/submit",
    method: "post",
    data: row,
  });
};

//submitBehavior

export const submitBehavior = (row) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/submit-behavior",
    method: "post",
    data: row,
  });
};

//timeline-list
export const repaymentTimelineList = (relationId) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/repayment-timeline-list",
    method: "get",
    params: {
      relationId,
    },
  });
};

//loanAfterTimelineList
export const loanAfterTimelineList = (loanInformationId, businessScene) => {
  return request({
    url: "/api/blade-loanBehaviorLog/loanBehaviorLog/loan-after-timeline-list",
    method: "get",
    params: {
      loanInformationId,
      businessScene,
    },
  });
};
